export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9050.be2121a2.jpg";